import * as hurricanes from './hurricane';
import * as layers from './layers';
import * as compare_layers from './compare-layers';
import * as external_layers from './external-layers';
import * as model_selection from './model-selection';
import * as remove_items from './remove';
import * as settings from './settings';
import * as share_view from './share';
import * as help_about from './help-about';
import * as update_user_profile from './update_user_profile';
import * as logout from './logout';

export default {
  layers,
  compare_layers,
  hurricanes,
  model_selection,
  external_layers,
  remove_items,
  settings,
  share_view,
  help_about,
  update_user_profile,
  logout
};
